/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { CrossIconContainer } from "../audit_log_modal/styles";
import ClearIcon from '@mui/icons-material/Clear';
import camelize from "../../utils/camelize";
import { IndexTable } from "../index_table";
import { MODAL_TABLE_MAX_HEIGHT } from "../index_table/styles";
import { formatDate } from "../../utils/formatDate";
import { StatusContainer } from "../../pages/reports/employee_discount_card_summary/styles";
import { StyledDialogTitle } from "./styles";

export const EmployeeCardAllocationLogsModal = ({ open, handleClose, selectedRecord }) => {

  const tableColumns = [
    'performed_by',
    'action_date',
    'action_type',
    'previous_status',
    'new_status',
  ];

  const columns = tableColumns?.map((column) => {
    return {
      key: column,
      label: camelize(column),
    };
  });

  const TableRows = (data) => {
    return data?.audit_logs?.map((record) => {
      return {
        performed_by: record?.performed_by,
        action_date: formatDate(record?.action_date, selectedRecord?.time_zone_abbr),
        action_type: camelize(record?.action_type),
        previous_status: record?.previous_status ? {
          display: (
            <div style={{ width: '175px' }}>
              <StatusContainer status={record?.previous_status}>
                {camelize(record?.previous_status)}
              </StatusContainer>
            </div>
          ),
          sortValue: record?.previous_status
        } : '-',
        new_status: {
          display: (
            <StatusContainer status={record?.new_status}>
              {camelize(record?.new_status)}
            </StatusContainer>
          ),
          sortValue: record?.new_status
        },
      };
    });
  };

  const rows = selectedRecord ? TableRows(selectedRecord) : [];

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"lg"}
      >
        <CrossIconContainer>
          <ClearIcon onClick={handleClose} />
        </CrossIconContainer>
        <StyledDialogTitle>
          Logs of <span style={{ fontWeight: 600 }}>{selectedRecord && selectedRecord[0]?.network_guest?.full_name}</span>
          &nbsp;for Perq Card <span style={{ fontWeight: 600 }}>{selectedRecord && selectedRecord[0]?.discount_card?.name}</span>:
        </StyledDialogTitle>
        <DialogContent
          sx={{
            overflowY: 'scroll',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': { display: 'none' }
          }}
        >
          <IndexTable
            maxHeight={MODAL_TABLE_MAX_HEIGHT}
            columns={columns}
            data={rows || []}
            tableId="card-allocation-logs"
            type="entries"
            page={1}
            report={false}
            hideNavigation={true}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}
